/*
 * @Author: Claude Code
 * @Date: 2026-03-03
 * @Description: Video Translation 功能卡片组件
 */
import { useRouter } from 'next/router';
import { memo } from 'react';

import { useRouteChange } from '@/hooks/useRouteChange';
import { useTranslate } from '@/hooks/useTranslate';
import { ROUTE_FROM } from '@/utils/const';
import { PageVisitFrom } from '@/utils/eventlog/eventNewConfig';
import { videoTranslateURL } from '@/utils/router';

import { HOME_FEATURE_VIDEOS } from '../../constants';

const VideoTranslationCard = memo(() => {
  const { t } = useTranslate();
  const { navigate } = useRouteChange();
  const router = useRouter();

  const handleClick = () => {
    sessionStorage.setItem(ROUTE_FROM, PageVisitFrom.HOME_CLICK);
    navigate(() => {
      router.replace(videoTranslateURL);
    });
  };

  return (
    <div
      className="relative flex flex-1 flex-col h-[242px] rounded-[8px] overflow-hidden cursor-pointer hover:translate-y-[-4px] transition-all"
      onClick={handleClick}
    >
      {/* 视频铺满整张卡片 */}
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        className="absolute inset-0 w-full h-full object-cover"
        src={HOME_FEATURE_VIDEOS.VIDEO_TRANSLATION}
      />

      {/* 文字信息区域 - 叠加在视频上方 */}
      <div className="relative z-10 mt-auto flex flex-col gap-[4px] px-[12px] py-[8px] backdrop-blur-[10px] bg-[rgba(0,0,0,0.2)]">
        <div className="text-[20px] font-bold text-white leading-[28px]">
          {t('merror.translation.title')}
        </div>
        <div className="text-[12px] text-[rgba(255,255,255,0.8)] leading-[18px]">
          {t('AI--')}
        </div>
      </div>
    </div>
  );
});

VideoTranslationCard.displayName = 'VideoTranslationCard';

export default VideoTranslationCard;
